var React = require('react');
var Griddle = require('griddle-react');
var moment = require('moment');

var OrderStatus = require('../../../containers/Admin/Requests/RequestsStatus');
var Actions = require('../../../containers/Admin/Requests/Actions');
var TimeFormatter = require('../../../containers/Formatters/TimeFormatter');
var EstimatedTimeFormatter = require('../../../containers/Formatters/EstimatedTimeFormatter');
var PriceFormatter = require('../../../containers/Formatters/PriceFormatter');

var rowMetadata = {
    "bodyCssClassName": function(rowData) {
        var createdAt = rowData.createdAt,
        	current = new Date().getTime(),
			pastTime  = moment(current).diff(createdAt),
			stateRow = moment.duration(pastTime).asMinutes() > 30 ? "late-request" : "standard-row";

		return stateRow;
    }
};


const rowData = [
	{
    	"columnName": "id",
    	"order": 1,
    	"visible": false
	},
	{
		"columnName": "createdAt",
		"order": 2,
		"visible": true,
		"displayName": "Tempo",
		"sortable": false,
		"customComponent": TimeFormatter
	},
	{
		"columnName": "order",
		"order":  3,
		"visible": true,
		"displayName": "Pedido",
		"sortable": false
	},
	{
		"columnName": "nameCourier",
		"order": 4,
		"visible": true,
		"displayName": "Entregador",
		"sortable": false
	},
	{
		"columnName": "phoneCourier",
		"order": 5,
		"visible": true,
		"displayName": "Telefone",
		"sortable": false
	},
	{
		"columnName": "nameClient",
		"order": 6,
		"visible": true,
		"displayName": "Cliente",
		"sortable": false
	},
	{
		"columnName": "phoneClient",
		"order":  7,
		"visible": true,
		"displayName": "Telefone",
		"sortable": false
	},
	{
		"columnName": "value",
    	"order": 8,
    	"visible": true,
    	"displayName": "Valor",
    	"sortable": false,
    	"customComponent": PriceFormatter
	},
	{
		"columnName": "courierValue",
    	"order": 9,
    	"visible": true,
    	"displayName": "Valor Entregador",
    	"sortable": false,
    	"customComponent": PriceFormatter
	},
	{
    	"columnName": "actions",
    	"order": 10,
    	"visible": true,
    	"displayName": "Ações",
    	"sortable": false,
    	"customComponent": Actions
	}
];

var Admin = React.createClass({
	
	render: function() {
		var me = this;

		return (
			<Griddle 
				results={me.props.data}
				rowMetadata={rowMetadata} 
				columnMetadata={rowData}
				showFilter={true}
				resultsPerPage={20}
				useGriddleStyles={false}
				tableClassName="table"
				sortDefaultComponent={<span className="icon-sort"></span>}
				sortAscendingComponent={<span className="icon-sort-down"></span>}
				sortDescendingComponent={<span className="icon-sort-up"></span>}
				filterPlaceholderText="Pesquisar"
				nextText="Próxima"
				previousText="Anterior"
				columns={[
					"createdAt", 
					"order",
					"nameCourier", 
					"phoneCourier", 
					"nameClient",
					"phoneClient",
					"value",
					"courierValue",
					"actions"
				]}
			/>
		);
	}

});

module.exports = Admin;


// WEBPACK FOOTER //
// ./src/components/Admin/Requests/Admin.jsx